import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Checkbox from 'shared/components/checkbox/Checkbox';
import Button from 'shared/components/button/Button';
import styles from './TermsAcceptanceModal.module.css';

function TermsAcceptanceModal({
  errorMessage = '',
  isLoading = false,
  onConfirm,
  show,
}) {
  const [acknowledged, setAcknowledged] = useState(false);

  useEffect(() => {
    if (show) {
      setAcknowledged(false);
    }
  }, [show]);

  return (
    <Modal show={show} centered size="lg" backdrop="static" keyboard={false}>
      <Modal.Header className={styles.header}>
        Notice: System Usage &amp; Security Policy
      </Modal.Header>
      <Modal.Body className={styles.body}>
        <p className={styles.intro}>
          To protect platform stability and intellectual property:
        </p>
        <ul className={styles.list}>
          <li>
            <strong>Individual Access Only: </strong>
            Credentials are strictly assigned to single individual users.
            Multi-user login sharing is prohibited.
          </li>
          <li>
            <strong>Automated Access Strictly Prohibited: </strong>
            Automated scraping, bot access, scripting, or reverse engineering of
            platform APIs and interfaces is prohibited.
          </li>
          <li>
            <strong>Rate Limiting &amp; Security Monitoring: </strong>
            Accounts exhibiting anomalous traffic volumes or automated behavior
            will be automatically suspended pending security review.
          </li>
        </ul>
        <div className={styles.checkboxRow}>
          <Checkbox
            label="I acknowledge and agree to the Acceptable Use Terms."
            active={acknowledged}
            onCheck={setAcknowledged}
            disabled={isLoading}
          />
        </div>
        {errorMessage && <p className={styles.error}>{errorMessage}</p>}
      </Modal.Body>
      <Modal.Footer className={styles.footer}>
        <Button
          text="Confirm"
          onClick={onConfirm}
          disabled={!acknowledged}
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
}

export default TermsAcceptanceModal;
